import { GAME_ALLOWED_PROJECTS } from 'assets/configurations/envConfigs';
import { TrophyIconComponent } from 'components/svgIcons/Trophy';
import { useUserSession } from 'common/stores/UserSessionStore';
import { PointsComponent } from 'components/score/Points';
import { UserMenuComponent } from 'components/UserMenu';
import { useGameScore } from 'common/stores/GameScore';
import { Link, useLoaderData } from "react-router-dom";
import Logo5 from "images/logo5.png";
import Logo6 from "images/logo6.png";
import React from 'react';


const [ DEFAULT_MODE ] = GAME_ALLOWED_PROJECTS;


export function HeaderBarComponent({
    className = '',
    logoPath = '',
    height = '50',
    hideScore = false,
    to = null
}) {
    //const { gameState = {} } = {}//useGameScore();
    const { params: { projectId } = {} } = useLoaderData() || {};
    const { getLeapAccount } = useUserSession();
    const { gameState } = useGameScore();
    const account = getLeapAccount();

    const lPath = projectId != null ? (projectId === '5' ? Logo5 : Logo6) : logoPath;
    height = projectId != null ? '90' : height;

    return (
        <header className={`header-bar ${className}`}>
            <div className="d-t-f main-wrapper">

                <div className="col logo-wrapper">
                    <Link to={to ? to : `/p/${projectId}/entry`} title="Orff Hero - 100% Música">
                        <img src={lPath} alt="Orff Hero - 100% Música" height={height} />
                    </Link>
                </div>

                {!account ? null : (
                    <>
                        {!hideScore ? (
                            <>
                                <div className="col trophy-wrapper">
                                    <TrophyIconComponent />
                                    <span className='pointing-label'>{gameState['total_trophies'] || 0}</span>
                                </div>
                                <div className="col points-wrapper">
                                    <PointsComponent score={gameState['total_points']} />
                                </div>
                            </>
                        ) : null}

                        <div className="col user-menu-wrapper">
                            <UserMenuComponent />
                        </div>
                    </>
                )}
            </div>
        </header>
    );
};